if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.title = this.dataset.title;
    }

    connectedCallback() {
      if (!this.productId) {
          this.closest('.shopify-section').classList.add('hidden');
          return;
      }

      fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${this.productId}`)
          .then(response => response.json())
          .then(({ products }) => {
              if (products.length < 0) {
                  this.closest('.shopify-section').classList.add('hidden');
                  return;
              }

              const productsToRender = products.filter(product => !(product.tags.find(tag => tag === 'newsite-hidden') || product.tags.find(tag => tag === 'base_product') || product.tags.find(tag => tag === 'hide_product')));

              this.innerHTML = `
                  <swiper-carousel
                      data-space-between="6"
                      data-slides-per-scroll="1"
                      data-slides-per-view="4"
                      data-mobile-slides-per-view="1.5"
                      class="block w-full"
                      aria-label="carousel"
                  >
                      
                      <div class="flex items-center pb-10">
                          ${this.title ? `<div class="text-2xl">${this.title}</div>` : ''}
                          <div class="md:flex ml-auto gap-[30px] hidden">
                              <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                                  <span class="block w-5 h-4 transform rotate-180"> 
                                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 14">
                                          <defs>
                                              <clipPath id="y6rs0ogsua">
                                                  <path data-name="Rectangle 21" d="M0 0h20v14H0z"/>
                                              </clipPath>
                                          </defs>
                                          <path fill="currentColor" data-name="Path 11" d="M19.647 5.872 14.047 0l-1.7 1.779L15.9 5.5H0v2.52h15.9l-3.55 3.724 1.7 1.779 5.6-5.872a1.3 1.3 0 0 0 0-1.779" transform="translate(0 .477)" style="clip-path:url(#y6rs0ogsua)"/>
                                      </svg>
                                  </span>
                              </button>
                              <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="next slide" data-next>
                                  <span class="block w-5 h-4"> 
                                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 14">
                                          <defs>
                                              <clipPath id="y6rs0ogsua">
                                                  <path data-name="Rectangle 21" d="M0 0h20v14H0z"/>
                                              </clipPath>
                                          </defs>
                                          <path fill="currentColor" data-name="Path 11" d="M19.647 5.872 14.047 0l-1.7 1.779L15.9 5.5H0v2.52h15.9l-3.55 3.724 1.7 1.779 5.6-5.872a1.3 1.3 0 0 0 0-1.779" transform="translate(0 .477)" style="clip-path:url(#y6rs0ogsua)"/>
                                      </svg>
                                  </span>
                              </button>
                          </div>
                      </div>
                      <a href="#rp-end-of-carousel" tabindex="0" class="skip-carousel">Skip carousel</a>
                      <div class="swiper-wrapper">
                          ${productsToRender.map((product) => `
                              <div class="swiper-slide aspect-[4/5] swiper-slide-visible swiper-slide-active" role="group" aria-label="1 / 7" style="width: 331px; margin-right: 4px;">
                                  <div class="group pb-9">
                                      <a href="${product.url}" class="flex flex-col">
                                          <div class="block bg-secondaryLight p-7 relative aspect-[4/5] flex items-center">
                                              <img src="${product.featured_image}" alt="${product.title}" width="1200" height="1200" data-featured-image="true" class="block object-cover w-full transform translate-y-0 duration-500 md:group-hover:-translate-y-[5%]">
                                          </div>
                                          <span class="block pt-5 h4 px-4 md:px-0">${product.title}</span>
                                          <strong data-product-subtitle="" class="py-3 h6 px-4 md:px-0 uppercase">
                                              ${product.type} &nbsp; ${product.options.length > 1 ? `• &nbsp; ${product.options.map((option) => (option.name.toLowerCase().includes('flavor') || option.name.toLowerCase().includes('color')) ? `${option.values[0]}` : '').join('')} &nbsp;` : ''}
                                          </strong>
                                          <span data-price-money="" class="h5 px-4 md:px-0">
                                              <span class="money">$${(product.price / 100).toFixed(2)}</span>
                                          </span>
                                      </a>
                                  </div>
                              </div>
                          `).join('')}                                
                      </div>
                  </swiper-carousel>
                  <span id="rp-end-of-carousel"></span>
              `;
          }
      );
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}
